import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AdministrationFrame } from '../../features/settings/components/administration-frame.js';
import { holdsPermission } from '../../session/permissions.js';
import { meQueryOptions } from '../../session/use-current-user.js';

/**
 * The tenant administration area.
 *
 * `config.read` is the permission to see it at all; writing and publishing are separate permissions
 * the screens inside check, because the catalogue has no hierarchy — `config.write` does not imply
 * `config.read`, and a role that needs both says both.
 *
 * The sidebar is mounted here rather than on each page, so a page added under `routes/admin/` is a
 * page the navigation can reach by being added to `features/settings/navigation.ts` — one list, and
 * nothing to keep in step with it.
 */
export const Route = createFileRoute('/admin')({
  async beforeLoad({ context }) {
    const me = await context.queryClient.ensureQueryData(meQueryOptions());
    if (!holdsPermission(me, 'config.read')) {
      throw redirect({ to: '/', search: { denied: 'config.read' } });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <AdministrationFrame>
      <Outlet />
    </AdministrationFrame>
  );
}
